import React from 'react';

import { RenderMachine, StepComponentProps } from 'components/Flow/RenderMachine';

import { nonprofitOnboardingCompanyAffiliationMachine } from './machine';
import { NonprofitOnboardingAffiliationFlowContext } from './context';

export const CompanyAffiliationStep = (
  props: StepComponentProps & { id?: string }
): JSX.Element | null => (
  <RenderMachine
    machine={nonprofitOnboardingCompanyAffiliationMachine}
    options={{
      context: {
        standaloneMode: props.standaloneMode,
      },
      actions: {
        handleFinal: () => props.send('NEXT'),
      },
      id: props.id,
    }}
    context={NonprofitOnboardingAffiliationFlowContext}
  />
);
